@import "../color/style.css";

:host {
	--smoothly-button-border-radius: 0.5rem;
	display: inline-flex;
	box-sizing: border-box;
	border-radius: var(--smoothly-button-border-radius);
	font-size: var(--smoothly-button-font-size, 1rem);
	cursor: pointer;
	border: none;
	outline: none;
	position: relative;
}
:host([shape=rounded]) {
	--smoothly-button-border-radius: 2rem;
}

:host([type=link]) {
	display: inline;
}

:host([disabled]) {
	opacity: 0.5;
}
:host>a {
	font-weight: 400;
	background-color: transparent;
}
:host>a,
:host>button {
	font-size: var(--smoothly-button-font-size);
	border: 1px solid transparent;
	outline: none;
	cursor: pointer;
	display: inline-flex;
	gap: 0.5rem;
	box-sizing: border-box;
}
:host>button {
	font-weight: bold;
	justify-content: center;
	width: 100%;
	align-items: center;
	border-radius: var(--smoothly-button-border-radius);
	padding-inline: var(--smoothly-button-padding-inline, 1rem);
}
:host {
	min-height: var(--smoothly-button-height, 2.5rem);
}

:host:has(> a:empty),
:host:has(> button:empty),
:host>a:empty,
:host>button:empty {
	border-width: 0;
	min-height: 0;
	padding-inline: 0;
}

:host([size=small]) {
	--smoothly-button-height: 2rem;
	--smoothly-button-padding-inline: 0.75rem;
	--smoothly-button-font-size: 0.875rem;
	--smoothly-icon-size: 1.4rem;
}
:host([size=large]) {
	--smoothly-button-height: 3rem;
	--smoothly-button-padding-inline: 1.25rem;
	--smoothly-button-font-size: 1.125rem;
}

:host(:not([size=icon]):not([size=flexible]))>button {
	min-width: 8rem;
}
:host([size=icon]) {
	--smoothly-icon-size: 1.4rem;
}
:host([size=icon])>button {
	min-height: var(--smoothly-button-height, 2.5rem);
	min-width: var(--smoothly-button-height, 2.5rem);
	padding: 0;
}

:host(:not([size=icon])) {
	min-width: 8em;
}

:host([size=flexible]) {
	min-width: unset;
	padding: 0;
	margin: 0;
	display: flex;
	justify-content: center;
}

:host([size=flexible])>button {
	min-width: unset;
	padding: 0;
	margin: 0;
}

:host([expand]) {
	width: 100%;
}

:host([expand=full]) {
	border-left: none;
	border-right: none;
	--smoothly-button-border-radius: 0;
}

:host([fill=outline])>button {
	background-color: transparent;
	color: rgb(var(--smoothly-button-foreground));
	fill: rgb(var(--smoothly-button-foreground));
	stroke: rgb(var(--smoothly-button-foreground));
	border-color: rgb(var(--smoothly-button-foreground));
}

:host(:not([fill=clear]):not([disabled]))>button:hover,
:host(:not([disabled]))>button:focus-visible,
:host([fill=outline]:not([disabled])):active>button::before {
	border-color: rgb(var(--smoothly-button-focus-color));
}

:host([fill=outline]:not([disabled]))>button:hover::before,
:host([fill=outline]:not([disabled]))>button:focus-within::before,
:host([fill=outline]:not([disabled]))>button:active::before {
	content: "";
	position: absolute;
	border: 2px solid rgb(var(--smoothly-button-focus-border));
	inset: -1px;
	border-radius: var(--smoothly-button-border-radius);
}

:host(:not([fill=clear]):not([fill=outline]):not([disabled]))>button:hover,
:host(:not([fill=clear]):not([fill=outline]):not([disabled]))>button:focus-visible,
:host(:not([fill=clear]):not([fill=outline]):not([disabled]))>button:active {
	background: rgb(var(--smoothly-button-hover-background));
}

:host>button,
:host ::slotted(smoothly-icon) {
	color: rgb(var(--smoothly-button-foreground));
	stroke: rgb(var(--smoothly-button-foreground));
	fill: rgb(var(--smoothly-button-foreground));
}

:host([hidden]) {
	display: none;
}
